import { render, staticRenderFns } from "./SportUpdateForm.vue?vue&type=template&id=4e3e74e6&"
import script from "./SportUpdateForm.vue?vue&type=script&lang=js&"
export * from "./SportUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports